<template>
  <!-- KPI / summary tile. Replaces the bespoke stat cards previously
       hand-built on the dashboard and IT/QA pages. -->
  <v-card class="int-stat pa-4 text-left" :class="{ 'int-hoverable': clickable }">
    <div class="d-flex align-center justify-space-between">
      <div class="int-stat-body">
        <div class="int-stat-label">{{ label }}</div>
        <div class="int-stat-value">{{ value }}</div>
        <div v-if="caption" class="int-stat-caption">{{ caption }}</div>
      </div>
      <v-avatar v-if="icon" size="42" :color="`${color}`" variant="tonal" class="int-stat-icon">
        <v-icon :color="color">{{ icon }}</v-icon>
      </v-avatar>
    </div>
    <slot />
  </v-card>
</template>

<script>
export default {
  name: 'StatCard',
  props: {
    label: { type: String, required: true },
    value: { type: [Number, String], default: 0 },
    caption: { type: String, default: '' },
    icon: { type: String, default: '' },
    color: { type: String, default: 'primary' },
    clickable: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.int-stat-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--int-text-muted);
  letter-spacing: 0.02em;
}
.int-stat-value {
  font-size: 1.7rem;
  font-weight: 800;
  color: var(--int-text-strong);
  line-height: 1.1;
}
.int-stat-caption {
  font-size: 0.74rem;
  color: var(--int-text-faint);
  margin-top: 2px;
}
.int-stat-body {
  min-width: 0;
}
</style>
